var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThunder2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 28,
    viewBox: "0 0 59 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1703 0.207833L26.4121 28.0051L26.2216 27.9037C27.1446 25.0813 28.0685 22.2589 29.039 19.2864C28.6733 19.3381 28.3917 19.3493 28.1273 19.4213C22.6971 20.898 17.2683 22.3809 11.8409 23.8698C8.20293 24.8735 4.57305 25.9086 0.939118 26.9274C0.63683 27.03 0.312713 27.0503 0 26.9862L25.0363 11.2541L25.1863 11.3717C24.781 12.8823 24.3758 14.3939 23.9159 16.1051L58.069 0L58.1703 0.207833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThunder2);
export default __webpack_public_path__ + "static/media/icon-thunder-2.46a298bc1ad3b8b84b7e38f7d0825751.svg";
export { ForwardRef as ReactComponent };